import "./Information.scss";
import Ticker from "../../assets/images/information/ticker.svg";
import Supply from "../../assets/images/information/supply.svg";
import BuyTax from "../../assets/images/information/buy-tax.svg";
import SellTax from "../../assets/images/information/sell-tax.svg";
import Blockchain from "../../assets/images/information/blockchain.svg";

export default function Information() {
	return (
		<div className="information">
			<div className="information-content-wrapper content-wrapper-lg">
				<ul className="information-items">
					<li className="information-item">
						<img className="information-logo" src={Ticker} alt="Nvidia" />
						<div className="information-title">Ticker:$IRIS</div>
					</li>
					<li className="information-item">
						<img className="information-logo" src={Supply} alt="IBM" />
						<div className="information-title">100 Million Total Supply </div>
					</li>
					<li className="information-item">
						<img className="information-logo" src={BuyTax} alt="OpenAI" />
						<div className="information-title">Buy tax 5% </div>
					</li>
					<li className="information-item">
						<img className="information-logo" src={SellTax} alt="Ethereum" />
						<div className="information-title">Sell tax 5% </div>
					</li>
					<li className="information-item">
						<img className="information-logo" src={Blockchain} alt="Fetch AI" />
						<div className="information-title">Blockchain: Ethereum</div>
					</li>
				</ul>
			</div>
		</div>
	);
}
